import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';




@Component({
  selector: 'app-competency-dashboard',
  templateUrl: './competency-dashboard.component.html',
  styleUrls: ['./competency-dashboard.component.scss']
})
export class CompetencyDashboardComponent implements OnInit {

  _isView = false
  dashboardTitle = 'Continue to Competencies'

  constructor(
    public _route: ActivatedRoute,
    private _router: Router,
  ) {
    this._route.queryParams.subscribe((params) => {
      console.log("THIS IS THE PARAMS DATA", params)
      if (params && params.type === 'list') this._isView = true
      else this._isView = false
    })
  }

  ngOnInit() {
  }



  // UTILITY


  competencyTypeChange() {
    this._isView = !this._isView
    let queryParams
    if (!this._isView) {
      this.dashboardTitle = 'Continue to Competencies'
      queryParams = { type: 'dashboard' }
    }
    if (this._isView) {
      this.dashboardTitle = 'Continue to Dashboard'
      queryParams = { type: 'list' }
    }
    this._router.navigate(
      [],
      {
        relativeTo: this._route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });

  }

}
